import React from "react";
import { Dropdown, Image, Menu } from "semantic-ui-react";
import { HashLink as Link } from 'react-router-hash-link';

const SignInMenu = ({ signOut, profile, auth}) => {
  return (
    <Menu.Item position="right">
      <Image avatar spaced="right" src={profile.photoURL || "/assets/user.png"} />
      <Dropdown pointing="top left" text={profile.displayName}>
        <Dropdown.Menu>
          <Dropdown.Item as={Link} to = {'/createEvent'} text="Create Event" icon="plus" />
          <Dropdown.Item as={Link} to = {`/profile/${auth.uid}#user-events`} text="My Events" icon="calendar" />
          <Dropdown.Item as={Link} to = {'/people'} text="My Network" icon="users" />
          <Dropdown.Item as={Link} to = {`/profile/${auth.uid}`} text="My Profile" icon="user" />
          <Dropdown.Item
            as={Link}
            to="/settings"
            text="Settings"
            icon="settings"
          />
          <Dropdown.Item onClick={signOut} text="Sign Out" icon="power" />
        </Dropdown.Menu>
      </Dropdown>
    </Menu.Item>
  );
};

export default SignInMenu;
